import { useEffect, useState } from "react";
import chatIcon from "../../assets/images/icons/chat.svg";
import more from "../../assets/images/icons/more_vert.svg";
import arrowDown from "../../assets/images/icons/arrow_down.svg";
import { useSelector } from "react-redux";
import axios from "axios";
import serverConfig from "../../utilities/serverConfig.json";
import RepeatVisitModal from "../../components/modals/auth/RepeatVisitModal";
import { convertDateStringToDaysAndMonthInPersian } from "../../utilities/functions/convertDateStringToDaysAndMonthInPersian";
import apiConfig from "../../utilities/apiConfig.json";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import scrollToTop from "../../utilities/functions/ScrollToTop";
import { Link } from "react-router-dom";
import IsLogin from "../../utilities/functions/isLogin";
import haveAccess from "../../utilities/functions/haveAccess";
import convertJalaliToMiladi from "../../utilities/functions/convertJalaliToMiladi";
import ApplyVisitModal from "../../components/modals/auth/ApplyVisitModal";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import TurnSkt from "../../components/Skeletons/TurnSkt";
import FiltersSkt from "../../components/Skeletons/FiltersSkt";

const maxVisiblePages = 5;
const getTurnsRoute = serverConfig.server.url + apiConfig.api.dashboardControllers.showEvents

const Turns = () => {

  const navigate = useNavigate();

  const { token, roles } = useSelector((state) => state.user);

  const tokenLocal = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [departmants, setDepartmants] = useState([])
  const [places, setPlaces] = useState([])
  const [searchValue, setSearchValue] = useState("");
  const [Turns, setTurns] = useState();
  const [loading, setLoading] = useState(true);
  const [paginationElem, setPaginationElem] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDoctorId, setModalDoctorId] = useState(null);
  const [modalEventId, setModalEventId] = useState(null);
  const [currentEventData, setCurrentEventData] = useState({});
  const [renderAllowed, setRenderAllowed] = useState(false)
  const [filterBy, setFilterBy] = useState('certain')
  const [filterByDepartmant, setFilterByDepartmant] = useState(null)
  const [filterByPlace, setfilterByPlace] = useState(null)

  const TurnsAPI = () => {

    let requestParams = {
      per_page: perPage,
      ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
      pagination: true,
    }

    if (filterBy && filterBy !== 'همه') {
      requestParams = { ...requestParams, status_filter: filterBy }
    }

    if (filterByDepartmant && filterByDepartmant !== 'all') {
      requestParams = { ...requestParams, department_id: filterByDepartmant }
    }

    if (filterByPlace && filterByPlace !== 'all') {
      requestParams = { ...requestParams, place_id: filterByPlace }
    }

    setLoading(true)

    axios
      .post(getTurnsRoute + "?page=" + currentPage, requestParams, { headers })
      .then((response) => {

        if (response.data.status === "success") {
          setTurns(response.data.data.events || []);
          const paginationItems = [];
          const totalPages = response.data.data.page_count;

          if (totalPages > 1) {
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisiblePages / 2)
            );
            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

            if (currentPage !== 1) {
              paginationItems.push(
                <li key="prev" className="page-item">
                  <Link
                    className="page-link 7"
                    to={window.location.href}
                    onClick={() => {
                      setCurrentPage(currentPage - 1);
                      scrollToTop();
                    }}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </Link>
                </li>
              );
            }
            if (currentPage !== 1 && currentPage !== 2) {
              paginationItems.push(
                <li key="first" className="page-item">
                  <Link
                    className="page-link 6"
                    to={window.location.href}
                    onClick={() => {
                      setCurrentPage(1);
                      scrollToTop();
                    }}
                  >
                    1
                  </Link>
                </li>
              );
            }
            if (startPage > 1) {
              paginationItems.push(
                <li key="ellipsis1" className="page-item disabled">
                  <span className="page-link 5">...</span>
                </li>
              );
            }
            for (let i = startPage; i < endPage; i++) {
              paginationItems.push(
                <li
                  key={i}
                  className={
                    "page-item 4" + (currentPage === i ? " active" : "")
                  }
                >
                  <Link
                    className="page-link 1"
                    to={window.location.href}
                    onClick={() => {
                      setCurrentPage(i);
                      scrollToTop();
                    }}
                  >
                    {i}
                  </Link>
                </li>
              );
            }
            if (endPage < totalPages) {
              paginationItems.push(
                <li key="ellipsis2" className="page-item disabled">
                  <span className="page-link 2">...</span>
                </li>
              );
            }
            paginationItems.push(
              <li key="last" className="page-item">
                <Link
                  className={`page-link${currentPage !== totalPages ? "" : " active"
                    }`}
                  to={window.location.href}
                  onClick={() => {
                    setCurrentPage(totalPages);
                    scrollToTop();
                  }}
                >
                  {totalPages}
                </Link>
              </li>
            );
            if (currentPage !== totalPages) {
              paginationItems.push(
                <li key="next" className="page-item">
                  <Link
                    className="page-link"
                    to={window.location.href}
                    onClick={() => {
                      setCurrentPage(currentPage + 1);
                      scrollToTop();
                    }}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </Link>
                </li>
              );
            }
            setPaginationElem(paginationItems);
          } else {
            setPaginationElem();
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        toast.error("Error making API call:", error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {

    const checkLoginStatus = async () => {

      const loggedIn = await IsLogin();

      if (loggedIn === false || loggedIn === "error api") {
        localStorage.getItem("FullName") && localStorage.removeItem("FullName");
        localStorage.getItem("mobile") && localStorage.removeItem("mobile");
        localStorage.getItem("token") && localStorage.removeItem("token");
        localStorage.setItem("callBackURL", window.location.pathname + window.location.search);
        navigate("/login");
      } else if (haveAccess(loggedIn, "turns_page")) setRenderAllowed(true)
      else navigate("/")

    };

    checkLoginStatus();
  }, []);

  useEffect(() => {
    renderAllowed && TurnsAPI();
  }, [currentPage, filterBy, filterByDepartmant, filterByPlace, renderAllowed]);

  const changeEventStatusAPI = (status, date, time, id) => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateEvent + id,
        {
          start: convertJalaliToMiladi(date) + " " + time,
          status: status,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    (
      async () => {

        try {

          const getDepartmantsRoute = serverConfig.server.url + apiConfig.api.getAPIs.getDepartments + '/by-role'

          const response = await axios.get(getDepartmantsRoute, { headers })

          if (response?.data?.status === 'success') {

            setDepartmants(response.data?.data?.departments_list)
            setPlaces(response.data?.data?.places_list)

            return
          }

          toast.error(response.data?.errors || response.statusText || response?.errors)

        } catch { toast.error('خطایی رخ داد بعدا تلاش کنید') }

      }
    )()
  }, [])

  const handleOpenModal = (doctorId, eventId) => {
    setModalDoctorId(doctorId);
    setModalEventId(eventId);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalDoctorId(null);
    setModalEventId(null);
  };

  const openAcceptanceButton = (eventData) => {
    setCurrentEventData(eventData);
  };

  return (
    <>

      {
        loading
          ?
          <FiltersSkt />
          :
          <div className="d-flex align-items-center gap-3">

            <FormControl className="tw-my-5" >

              <InputLabel id="demo-simple-select-label">فیلتر</InputLabel>

              <Select
                MenuProps={{ disableScrollLock: true }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterBy}
                label="فیلتر"
                onChange={e => setFilterBy(e.target?.value)}
              >
                <MenuItem value={'certain'}>در انتظار مراجعه</MenuItem>
                <MenuItem value={'همه'}>همه</MenuItem>
                <MenuItem value={'temp'}>معلق شده</MenuItem>
                <MenuItem value={'done'}>ویزیت شده</MenuItem>
              </Select>

            </FormControl>

            <FormControl className="tw-my-5">

              <InputLabel id="departmantItems">دپارتمان</InputLabel>

              <Select
                MenuProps={{ disableScrollLock: true }}
                labelId="departmantItems"
                id="departmantItems"
                label="دپارتمان"
                value={filterByDepartmant ?? 'all'}
                onChange={e => setFilterByDepartmant(e.target?.value)}
              >

                <MenuItem value={'all'}>همه</MenuItem>

                {
                  departmants?.length
                  &&
                  departmants.map(data => (
                    <MenuItem
                      key={data.title + data.id}
                      value={data.id}>
                      {data.title}
                    </MenuItem>
                  ))
                }

              </Select>

            </FormControl>

            <FormControl className="tw-my-5">

              <InputLabel id="placesItems">مکان ها</InputLabel>

              <Select
                MenuProps={{ disableScrollLock: true }}
                labelId="placesItems"
                id="placesItems"
                label="مکان ها"
                value={filterByPlace ?? 'all'}
                onChange={e => setfilterByPlace(e.target?.value)}
              >

                <MenuItem value={'all'}>همه</MenuItem>

                {
                  places?.length
                  &&
                  places.map(data => (
                    <MenuItem
                      key={data.title + data.id}
                      value={data.id}>
                      {data.title}
                    </MenuItem>
                  ))
                }

              </Select>

            </FormControl>

          </div>
      }

      <div className="row row-cols-1 row-cols-lg-2 g-2 g-lg-4">
        {
          loading
            ?
            <TurnSkt count={6} />
            :
            Turns?.length
              ?
              Turns.map((element, index) => (
                <div key={element.event_id} className="col">
                  <div
                    className="border-gray-300 border-radius-8 bg-white p-2"
                    onClick={() => openAcceptanceButton(element)}
                  >
                    <div className="d-flex justify-content-between gap-1">
                      <div className="d-flex justify-content-between flex-grow-1 flex-shrink-1 align-items-center  border-radius-8 background-bootstrap-gray-100  p-2 col-lg-9 ">
                        <span className="fw-normal fs-14 color-bootstrap-gray-700">
                          {element?.day +
                            " " +
                            convertDateStringToDaysAndMonthInPersian(element?.date)}
                        </span>
                        <span className="fw-normal fs-14 color-bootstrap-gray-700">
                          {element?.time}
                        </span>
                      </div>
                      <div className="d-flex gap-2 position-relative">
                        <span className="notifNum position-absolute border-radius-32 fw-normal fs-10 color-iso-white background-bootstrap-gray-700">
                          {element?.comments_count}
                        </span>
                        <div
                          className=" border-radius-8 p-2 border-gray-300 background-bootstrap-gray-100"
                          onClick={() =>
                            handleOpenModal(element?.doctor_id, element?.event_id)
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#applyVisitModal"
                        >
                          <img src={chatIcon} alt="" />
                        </div>

                        <div className=" border-radius-8 p-2 border-gray-300 background-bootstrap-gray-100 ">
                          <img src={more} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-2 border-radius-8 p-2 border-gray-300 background-bootstrap-gray-100">
                      <div>
                        <span className="fw-medium fs-14 color-bootstrap-gray-700">
                          هزینه پرداخت شده
                        </span>
                      </div>
                      <div className="d-flex gap-2">
                        <span className="">
                          {element?.final_amount?.toLocaleString("fa-IR")}{" "}
                          <span className="fs-10">تومان</span>
                        </span>
                        <span>
                          <img src={arrowDown} alt="" />
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-2 tw-gap-2">
                      <div className="w-100 m-auto row row-cols-2 align-items-center">
                        <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                          پزشک
                          <span className="ms-1 d-block fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                            {element?.doctor_title ?? ''} {element?.doctor_first_name} {element?.doctor_last_name}
                          </span>
                        </span>
                        <span className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                          تلفن بیمار
                          <span className="ms-1 d-block fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                            {element?.patient_mobile}
                          </span>
                        </span>
                      </div>

                      <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                        نام بیمار :
                        <span className="ms-1 fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                          {element?.patient_first_name} {element?.patient_last_name}
                        </span>
                      </div>

                      {
                        element?.insurance_name ?
                          <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                            بیمه :
                            <span className="ms-1 fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                              {element.insurance_name}
                            </span>
                          </div>
                          :
                          null
                      }

                      <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                        مرکز درمانی :
                        <span className="ms-1 fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                          {element?.place_title}
                        </span>
                      </div>

                      <div className="ps-2 my-1 fw-medium fs-14 color-bootstrap-gray-800">
                        دپارتمان :
                        <span className="ms-1 fw-normal fs-14 mt-1 color-bootstrap-gray-600">
                          {element?.department_title}
                        </span>
                      </div>

                      <div className="d-flex gap-2 ps-2 mb-4 mt-2">
                        <span className="visitTimeTurn border-radius-24 background-bootstrap-gray-200 fw-normal fs-12 color-bootstrap-gray-700">
                          {element.status}
                        </span>

                        {element?.pay_status === "unpaid" ? (
                          <span className="waitToPayTurn background-bootstrap-light-warning border-radius-24 fw-normal fs-12">
                            درانتظار پرداخت
                          </span>
                        ) : (
                          <span className="paidTpPayTurn border-radius-24 fw-normal fs-12 color-bootstrap-regular-success">
                            پرداخت شده
                          </span>
                        )}

                        <span className="visitTimeTurn border-radius-24 background-bootstrap-gray-200 fw-normal fs-12 color-bootstrap-gray-700">
                          {element?.type}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex gap-2 align-items-center justify-content-center mt-auto mx-2">
                      <button
                        className="buttonAcceptance border-radius-8 bg-white fs-14 border-iso-blue-300 color-iso-blue-300 col-4"
                        data-bs-toggle="modal"
                        data-bs-target="#repeatVisitModal"
                      >
                        ویزیت شد
                      </button>
                      <button
                        className="buttonAcceptance text-nowrap border-radius-8 bg-white fs-14 border-iso-blue-300 color-iso-blue-300 col-4"
                        onClick={() => {
                          navigate(
                            `/booking?pl=${element?.place_id}&dep=${element?.department_id}&dr=${element?.doctor_id}`
                          );
                        }}
                      >
                        نوبت مجدد
                      </button>
                      <button
                        className="buttonApplyVisit col-4 border-radius-8 border-0 fw-medium fs-16 bg-iso-blue-300 color-bootstrap-gray-100"
                        onClick={() => {
                          navigate(`/turn?${"id=" + element?.event_id}`);
                        }}
                      >
                        جزئیات
                      </button>
                    </div>
                  </div>
                </div>
              ))
              :
              <>
                {
                  !loading
                    ?
                    <div className="tw-w-full tw-flex tw-items-center tw-justify-center fs-16 fw-bold tw-mt-56 tw-cursor-auto *:tw-cursor-auto *:*:tw-cursor-auto">نتیجه ای یافت نشد</div>
                    : null
                }
              </>
        }
      </div>

      <>
        <RepeatVisitModal
          id={currentEventData?.event_id}
          updateTurns={id => setTurns(prev => prev.filter(turn => turn.event_id !== id))}
          currentTotalVisitAmount={currentEventData?.total_visit_amount}
        />
        {
          currentEventData?.token && (
            <form
              action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
              method="post"
            >
              <input type="hidden" name="Token" value={currentEventData?.token} />
              <input type="hidden" name="GetMethod" value="true" />
            </form>
          )
        }
      </>

      <div className="card-pagination mt-3 justify-content-center">
        <nav aria-label="Page navigation example">
          <ul className="pagination justify-content-center">
            {paginationElem}
          </ul>
        </nav>
      </div>

      <ApplyVisitModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        doctorId={modalDoctorId}
        id={modalEventId}
      />
    </>
  );
};
export default Turns;
